/**
 * mtc-backoffice-api
 * MTC Backoffice Composite Api
 *
 * OpenAPI spec version: 0.1.0-SNAPSHOT
 * Contact: developers@greysystems.eu
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface AgentSearchFilter { 
    /**
     * By agent code
     */
    code?: string;
    /**
     * By agent fax
     */
    fax?: string;
    /**
     * By agent city
     */
    idCity?: number;
    /**
     * By company id
     */
    idCompany?: number;
    /**
     * Is receiver agent
     */
    isReceiver?: boolean;
    /**
     * Is Sender agent
     */
    isSender?: boolean;
    /**
     * By agent display name
     */
    name?: string;
    /**
     * By agent phone
     */
    phone?: string;
    /**
     * By agent postal code
     */
    postalCode?: string;
    /**
     * By agent status
     */
    status?: AgentSearchFilter.StatusEnum;
}
export namespace AgentSearchFilter {
    export type StatusEnum = 'Active' | 'Inactive' | 'Sign_Out' | 'Pending';
    export const StatusEnum = {
        Active: 'Active' as StatusEnum,
        Inactive: 'Inactive' as StatusEnum,
        SignOut: 'Sign_Out' as StatusEnum,
        Pending: 'Pending' as StatusEnum
    };
}
